export const AIMS_BACKEND_URL = process.env.REACT_APP_AIMS_BACKEND_URL;
export const AIMS_RESET_PASSWORD_URL =
  process.env.REACT_APP_AIMS_RESET_PASSWORD_URL;
export const AIMS_SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const AIMS_INITIAL_VECTOR = process.env.REACT_APP_INITIAL_VECTOR;
export const PRIMARY_COLOR = "rgb(22, 177, 255)";
